let baseUrl = 'https://api.sfgy.org/';
// let baseUrl = "http://100.118.146.64/index.php/"
// let baseUrl = "http://127.0.0.1/index.php/"
// let baseUrl = "http://api.sf.1si.com.cn/"
export default baseUrl;



// WEBPACK FOOTER //
// ./src/config/index.js